import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 48000-48999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const currencyErrors = {
  // 48xxx currency. Its "Project not found." site reused PROJECT_NOT_FOUND.
  CURRENCY_CREATE_FAILED: {
    errorCode: 48001,
    errorMessage: t("The currency could not be created."),
    isDynamic: false,
  },
  CURRENCY_UPDATE_MATCHED_NOTHING: {
    errorCode: 48002,
    errorMessage: t("No currency was updated — the ids match no currency on this portal."),
    isDynamic: false,
  },
  CURRENCY_DELETE_MATCHED_NOTHING: {
    errorCode: 48003,
    errorMessage: t("No currency was deleted — the ids match no currency on this portal."),
    isDynamic: false,
  },
  CURRENCY_NAME_AND_CATEGORY_REQUIRED: {
    errorCode: 48004,
    errorMessage: t("Currency name and category are required to create a currency."),
    isDynamic: false,
  },
  CURRENCY_OR_SYMBOL_NOT_FOUND: {
    errorCode: 48005,
    errorMessage: t("Currency or symbol not found."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
